import { Component, Input } from '@angular/core';
import { NgControl, FormControlName } from '@angular/forms';

@Component({
  selector: 'lebara-base',
  template: ''
})
export abstract class InputBaseComponent {
  public me: NgControl;
  public onChange: any = () => { };
  public onTouch: any = () => { };

  @Input('formControlName') formControlName!: string;

  constructor(me: NgControl) {
    this.me = me;
  }

  public get id(): string {
    return `ID_${this.formControlName}`.replace(':', '_');
  }

  public get textLabelName(): string {
    return `${this.formControlName}_text`.replace(':', '.');
  }

  public get submitted(): boolean {
    return (this.me as FormControlName).formDirective.submitted;
  }

  public get invalid(): boolean {
    return this.me.invalid && this.me.touched ||
      this.submitted && this.me.invalid || false;
  }

  public get errormessage(): string {
    if (this.me && this.me.errors) {

      for (const propertyName in this.me.errors) {
        if (this.me.errors[propertyName]) {
          return `${this.formControlName}_${propertyName}`.replace(':', '.');
        }
      }
    }
    return 'no errors found';
  }

  public abstract set value(val: any);

  // this method sets the value programmatically
  public abstract writeValue(value: any): void;

   // upon UI element value changes, this method gets triggered
   public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  // upon touching the element, this method gets triggered
  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

}
